import { render, staticRenderFns } from "./CustomerAppt.vue?vue&type=template&id=37d09400&scoped=true&"
import script from "./CustomerAppt.vue?vue&type=script&lang=js&"
export * from "./CustomerAppt.vue?vue&type=script&lang=js&"
import style0 from "./CustomerAppt.vue?vue&type=style&index=0&id=37d09400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d09400",
  null
  
)

export default component.exports